<script lang="ts" setup>
const { data } = await useAsyncData(
  'recent_blog_posts', 
  () => $fetch('/api/blog/posts?limit=4&sort=-createdAt'),
);

</script>
<template>
  <section v-if="data?.docs.length" class="block w-full py-10 mx-auto max-w-container-ws p-9 lg:p-9">
    <span class="block my-5 uppercase">
      {{ $t('READ_OUR_BLOG') }}
    </span>

    <h3 class="text-2xl md:text-4xl font-bold w-full mb-8 mt-3">
      {{ $t('LATEST_ARTICLES') }}
    </h3>

    <!-- Cards -->
    <ul>
      <BlogCard
        v-for="(post, idx) in data?.docs"
        :key="post.id"
        :title="post.title"
        :description="post.excerpt"
        :created-at="post.createdAt"
        :category="post.categories[0]?.name"
        :show-img="post.featuredImage"
        :cover="post.featuredImage?.url || ''"
        :compact="idx > 0"
        :slug="post.slug"
      />
    </ul>
  </section>
</template>

<style lang="scss" scoped>
h3 {
  max-width: 680px;
}

ul {
  display: flex;
  flex-direction: column;

  li {
    grid-area: b;

    &:first-child {
      grid-area: a;
    }

    &:nth-child(2) {
      grid-area: b;
    }

    &:nth-child(3) {
      grid-area: c;
    }
  }
}

@media (screen(lg)) {
  ul {
    display: grid;
    grid-template-columns: 1fr 290px 1fr;
    grid-template-rows: 208px 208px 208px;
    gap: 30px 30px;
    grid-template-areas:
    "a a b"
    "a a c"
    "a a d";
  }
}
</style>